<template>
  <v-layout row wrap my-3 mx-5>
    <v-flex xs12>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Whatsapp Mass Campaign
        </v-card-title>
        <v-card-actions class="px-3">
          <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="pickFile ()"
              :disabled="loading"
            >
              Select File
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <v-text-field
              label="file"
              v-model="name"
              readonly
              disabled
              class="mx-2"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
            <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="loadFile()"
            >
              Load
            <v-icon right dark>clear_all</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-layout row wrap>
          <v-flex xs12 pa-3>
            Table should have 3 columns
            <span class="red--text">Firstname - Lastname - Number</span>
            
          </v-flex>
          <v-flex xs12 pa-3>
            <v-data-table
              :headers="detailedViewsHeaders"
              :items="detailedViews"
              class="elevation-3"
              v-model="selected"
              select-all
              item-key="Number"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </td>
                <td v-for="p in props.item" :key="p" class="text-xs-left">{{ p }}</td>
                
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 px-3 py-1>
            <span class="my-3">Use <span class="red--text">|Firstname|</span> &/OR <span class="red--text">|Lastname|</span> to include name</span>
          </v-flex>
          <v-flex xs12 pa-3>
            <v-textarea
              solo
              label="Message"
              v-model="sMessage"
            ></v-textarea>
          </v-flex>
        </v-layout>
        <v-card-actions class="px-3">
          <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="pickFile ()"
              :disabled="loading"
            >
              Select File
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <v-text-field
              label="file"
              v-model="name"
              readonly
              disabled
              class="mx-2"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
            <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="loadFile()"
            >
              Load
            <v-icon right dark>clear_all</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            @click="sendToAll()"  
            color="primary" 
            :loading="loading"
            dark>
          Send Message to {{this.selected.length}} Contacts</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import {firebase, db, auth} from '@/fb';


export default {
  data() {
    return {
      url:null,
      name:null,
      file:null,
      loading:false,
      sNumber:null,
      sMessage:null,
      csv:null,
      qr:null,
      messagesH:[],
      messages:[],
      detailedViewsHeaders:[],
      detailedViews:[],
      contacts:[],
      contactedNumbers:[],
      selectedNumber:null,
      selected:[],
      selectedNumberChat:null,
      chatMessages:[],
      myMSGS:[],
      clientMSGS:[],
      numbersMass:[],
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path)
    },
    sendToAll(){
      if (this.selected.length == 0 || !this.sMessage) {
        return
      }
      this.loading = true
      let count = 0
      this.selected.forEach(contact=>{
        let token = 'upzjdoldmyhi9xyz'
        axios.get(`https://eu10.chat-api.com/instance37583/status?token=${token}`)
        .then(resp=>{
          console.log('------------------------------------');
          console.log(resp);
          this.qr = resp.data.qrCode
          if (resp.data.accountStatus == 'authenticated') {
            var headers = {
              'Accept': 'application/json'
            }
            let post = {
              phone:parseInt(contact.Number),
              body:this.sMessage.replace(/\|Lastname\|/g, contact.Lastname).replace(/\|Firstname\|/g, contact.Firstname)
            }
            axios.post(`https://eu10.chat-api.com/instance37583/sendMessage?token=${token}`, post, {headers: headers})
            .then(resp=>{
              if (resp.data.sent) {
                console.log(resp.data)
                let uid = uuid()
                db.ref(`whatsapp/numbers/${post.phone}`)
                .update({
                  number:post.phone,
                  firstname:contact.Firstname,
                  lastname:contact.Lastname
                })
                count++
                if (count == this.selected.length) {
                  this.loading = false
                  this.$emit('alertNotification', `Messages sent to All`, 'success')
                  this.goTo('/wa-chat')
                }
                
              }
            })
          }
          console.log('------------------------------------');
        })
      })
    },
    pickFile () {
      this.$refs.file.click ()
    },
    loadFile(){
      this.detailedViewsHeaders = []
      this.detailedViews = []
      console.log('------------------------------------');
      console.log(this.csv);
      console.log('------------------------------------');
      this.csv.meta.fields.forEach(el => {
        this.detailedViewsHeaders.push({
          text:el,
          value:el
        })
      });
      this.detailedViews = this.csv.data
      this.numbersMass
    },
    onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
          this.name = files[0].name
					this.url = fr.result
          this.file = files[0] // this is an image file that can be sent to server...
          Papa.parse(this.file, {
            header: true,
            complete: (d)=>{
              this.csv = d
            }
          })
				})
			} else {
				this.name = null
				this.fule = null
				this.url = null
			}
    },
  },
  watch:{
    selected(){
      console.log(this.selected)
    }
  },
  created() {
  }
}
</script>

<style>

</style>
